import {
  Badge,
  Breadcrumb,
  Button,
  Card,
  Col,
  DatePicker,
  Divider,
  Drawer,
  Form,
  Image,
  Popover,
  Radio,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Tooltip,
  Typography,
} from "antd";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import "./ProductDetailPage.css";
import { ReactComponent as Info } from "../././../../../assests/info.svg";
import { ReactComponent as CalendarX } from "../././../../../assests/calendar-x.svg";
import { ReactComponent as ChartLine } from "../././../../../assests/chart-line.svg";
import { ReactComponent as SealCheck } from "../././../../../assests/seal-check.svg";
import { ReactComponent as Arrow } from "../././../../../assests/Arrow 3.svg";
import GoogleMapsComponent from "../../map-view/GoogleMapsComponent";
import { ReactComponent as SelectUpIcon } from "../././../../../assests/select-up-icon.svg";
import { ReactComponent as SelectDownIcon } from "../././../../../assests/select-down-icon.svg";
import {
  checkProductAvailabilityQuantity,
  checkProductAvailabilityQuantityBeforeLogin,
  createNewCampaign,
  getUserSavedCampaigns,
  productExpiryNotify,
} from "../../../../store/thunks/buyer-thunks/BuyerThunks";
import FloatingInput from "../../float-input/FloatInput";
import dayjs from "dayjs";
import {
  getSingleProductDetails,
  getSingleProductDetailsBeforeLogin,
} from "../../../../store/thunks/common-thunks/commonThunk";
import { ReactComponent as NotifyIcon } from "../../../../assests/notify-icon.svg";
import { addBreadcrumb } from "../../../../store/slices/common-slice/bread-crumbs/BreadCrumbSlice";
import moment from "moment-timezone";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { API_BASE_URL_IMAGE } from "../../../../services/common";
import enUS from "antd/es/calendar/locale/en_US";
import dummyImage from "../../../../assests/images/no-image.png";
import LoginAlert from "../../../modal/login-alert/LoginAlert";
import {
  formatBillboardSize,
  formatMetric,
  formatToUSCurrency,
  handleCopy,
  formatLocation,
} from "../../utils/Utils";
import {
  ArrowRightOutlined,
  CheckOutlined,
  ClockCircleOutlined,
  CloseOutlined,
  CopyOutlined,
  LockOutlined,
  MinusOutlined,
  PlusOutlined,
  WarningOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import FloatingTextArea from "../../floating-textarea/FloatingTextArea";
import FormItem from "antd/es/form/FormItem";
import BreadcrumbNav from "../../bread-crumbs/BreadCrumb";
import { useMediaQuery } from "react-responsive";
import FooterSection from "../../../layout/footer/Footer";
import { message } from "antd";
import { Statistic } from "antd";
import { createPortal } from "react-dom";
import { getPricePredictionOfProducts } from "../../../../store/thunks/common-thunks/commonThunk";
import ChatBotSparkles from "../../../../assests/chatbot-sparklesIcon.svg";

const { RangePicker } = DatePicker;
const { Countdown } = Statistic;
const formatProductDate = (timestamp) => {
  return timestamp ? dayjs(Number(timestamp)) : null;
};
const ProductDetailPage = () => {
  const location = useLocation();
  const { Option } = Select;
  const { isCampaignsPage } = location.state || {};
  const { Text, Paragraph, Title } = Typography;
  const isSmall = useMediaQuery({ maxWidth: 1200 });
  const isExtraSmall = useMediaQuery({ maxWidth: 996 });
  const isMobile = useMediaQuery({ maxWidth: 768.5 });
  const dispatch = useDispatch();
  const userDetails = JSON.parse(localStorage.getItem("user"))?.user;
  const datePickerRef = useRef(null);
  const [selectedCampaign, setSelectedCampaign] = useState("");
  const [campaignId, setCampaignId] = useState("");
  const [selectedRanges, setSelectedRanges] = useState([
    {
      id: 1,
      label: "S1",
      dates: [],
      quantity: 0,
      availableQuantity: 0,
    },
  ]);
  const [activeRangeIndex, setActiveRangeIndex] = useState(0);
  const [hoveredDate, setHoveredDate] = useState(null);
  const selectedDates = selectedRanges?.[activeRangeIndex]?.dates || [];
  const hasSelectedRanges = selectedRanges?.some(
    (range) => range?.dates?.[0] && range?.dates?.[1],
  );
  const availabilityRequestRangeIdRef = useRef(null);
  const nextRangeIdRef = useRef(2);
  const [panelMode, setPanelMode] = useState("date");
  const [campaignName, setCampaignName] = useState("");
  const [isNewcampaign, setIsNewCampaign] = useState(false);
  const [product, setProduct] = useState();
  const images = product?.image;
  const [activeImage, setActiveImage] = useState(null);
  const expiryTime = product?.reservation_expire_time?.date;
  const expiryTimestamp = expiryTime
    ? new Date(expiryTime.replace(" ", "T") + "Z").getTime()
    : null;
  const [isExpiringSoon, setIsExpiringSoon] = useState(false);
  const loggedInUser = JSON.parse(localStorage.getItem("user"))?.user;
  const currentUserSession = loggedInUser?.user_id;
  const reservationUserSession = product?.reservation_user_session;
  const isOwnReservation = currentUserSession === reservationUserSession;
  const isProductReserved = !!(
    expiryTimestamp &&
    expiryTimestamp > Date.now() &&
    product?.reservation_user_session
  );
  const [form] = Form.useForm();
  const isLoggedIn = useSelector((state) => state.login.isAuthenticated);
  const [loginPopoverVisible, setLoginPopoverVisible] = useState(false);
  const [campaignDetails, setCampaignDetails] = useState({});
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [totalPrice, setTotalPrice] = useState();
  const [selectedQuantity, setSelectedQuantity] = useState(1);
  const [campaignOption, setCampaignOption] = useState("existing");
  const [predictedPrice, setPredictedPrice] = useState([]);
  const [productId, setProductId] = useState("");
  const { predictionLoader, prices } = useSelector((state) => state.products);
  const getPredictedPrice = (priceValue) => {
    if (!priceValue) return "";
    let modifiedNumber = priceValue.split("$");
    return Number(modifiedNumber[1]).toFixed(2);
  };

  const estimatedPriceTooltip = () => {
    return "This is an estimated market price generated by AI to guide you. The actual seller's price may differ.";
  };

  const isEstimatedMarketValue =
    Number(product?.rateCard) === 0 &&
    product?.rateCard !== null &&
    product?.rateCard !== undefined &&
    product?.rateCard !== "";
  const {
    savedCampaigns,
    isLoading: buyerCampaignsLoader,
    productAvailabilityQuantity,
    buyerSavedCampaignsLoader,
  } = useSelector((state) => state.buyerCampaigns);
  const { singleProduct, isLoading: productsLoader } = useSelector(
    (state) => state.products,
  );
  const params = new URLSearchParams(location.search);
  const other_id = params.get("_id");
  const floatingInputStyles = {
    marginTop: "0px",
    "--input-font-weight": "500",
    "--label-focused-top": "23px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "0.5rem",
  };

  const disableHoldDates = useMemo(() => {
    const holdDates = singleProduct?.ProductHoldDates;
    if (!holdDates) {
      return [];
    }
    // Backend can return either object or array
    const holdDateRanges = Array.isArray(holdDates) ? holdDates : [holdDates];
    return holdDateRanges
      ?.filter((item) => item?.hold_request_start && item?.due_date)
      ?.map((item) => ({
        start: moment(item?.hold_request_start).startOf("day"),
        end: moment(item?.due_date).startOf("day"),
      }));
  }, [singleProduct?.ProductHoldDates]);
  const textAreaFloatingInputStyles = {
    "--input-height": "120px",
    "--label-font-size": "10px",
    "--input-font-weight": 500,
    "--input-padding-top": "1rem",
    "--label-focused-top": "22px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "10px",
  };
  const isLoading = buyerCampaignsLoader || productsLoader;
  const selectedCampaignId = localStorage.getItem("campaignId");
  const selectedCampaignName = localStorage.getItem("CampaignName");
  const campaignFlag = localStorage.getItem("campaignFlag");
  const [panelMonth, setPanelMonth] = useState(dayjs());
  const [showMap, setShowMap] = useState(false);
  const [productLocations, setProductLocations] = useState(null);

  const navigate = useNavigate();
  const userType = JSON.parse(localStorage.getItem("user"))?.user?.user_type;

  //Store all available slots in an array
  const availableSlots = Array.isArray(product?.from_date)
    ? product?.from_date.map((from, index) => ({
        start: dayjs(Number(from?.$date?.$numberLong)).startOf("day"),
        end: dayjs(Number(product?.to_date?.[index]?.$date?.$numberLong)).endOf(
          "day",
        ),
      }))
    : [
        {
          start: formatProductDate(
            product?.from_date?.$date?.$numberLong,
          )?.startOf("day"),
          end: formatProductDate(product?.to_date?.$date?.$numberLong)?.endOf(
            "day",
          ),
        },
      ];
  // Used for the disable unavailable months in calendar
  const isMonthAvailable = (monthDate) => {
    return availableSlots.some((slot) => {
      const slotStartMonth = slot?.start?.startOf("month");
      const slotEndMonth = slot?.end?.startOf("month");
      return (
        monthDate.isSame(slotStartMonth, "month") ||
        monthDate.isSame(slotEndMonth, "month") ||
        (monthDate.isAfter(slotStartMonth, "month") &&
          monthDate.isBefore(slotEndMonth, "month"))
      );
    });
  };
  // Used for the disable unavailable years in calendar
  const isYearAvailable = (yearDate) => {
    return availableSlots?.some((slot) => {
      return (
        yearDate.year() >= slot?.start?.year() &&
        yearDate.year() <= slot?.end?.year()
      );
    });
  };
  // Disable dates for range picker based on product's available dates and timezone
  const disableProductDatesForRangepicker = (current) => {
    // if (isProductReserved) {
    //   return true;
    // }
    if (!product?.area_time_zone_type) return true;
    if (panelMode === "month") {
      return !isMonthAvailable(current);
    }
    if (panelMode === "year") {
      return !isYearAvailable(current);
    }
    const timeZone = product?.area_time_zone_type;
    const todayInTZ = moment()?.tz(timeZone)?.startOf("day");
    if (current.isBefore(todayInTZ, "day")) {
      return true;
    }
    const isAvailable = availableSlots?.some((slot) => {
      return (
        current.isSame(slot?.start, "day") ||
        current.isSame(slot?.end, "day") ||
        (current.isAfter(slot?.start, "day") &&
          current.isBefore(slot?.end, "day"))
      );
    });
    if (!isAvailable) {
      return true;
    }
    // Disable hold request dates
    const isHoldDate = disableHoldDates.some(
      ({ start, end }) =>
        (current?.isSame(start, "day") || current?.isAfter(start, "day")) &&
        (current?.isSame(end, "day") || current?.isBefore(end, "day")),
    );
    if (isHoldDate) {
      return true;
    }
    //disable already selected slots dates
    return isDateInAnotherRange(current);
  };

  const customLocale = {
    ...enUS,
    lang: {
      ...enUS.lang,
      shortWeekDays: ["S", "M", "T", "W", "T", "F", "S"],
    },
  };

  // Function to navigate to appropriate campaign page through a breadcrumbs
  const goToSubPage = () => {
    dispatch(
      addBreadcrumb({
        title: campaignFlag == 1 ? selectedCampaignName : "Campaigns",
        path:
          campaignFlag == 1
            ? `/buyer/campaigndetails?_id=${btoa(selectedCampaignId)}`
            : "/buyer/mycampaigns?segment=saved_campaign",
      }),
    );
    if (campaignFlag == 1) {
      navigate(`/buyer/campaigndetails?_id=${btoa(selectedCampaignId)}`);
      localStorage.setItem("campaignFlag", 0);
    } else {
      navigate("/buyer/mycampaigns");
      localStorage?.setItem("campaignFlag", 0);
    }
  };

  // Used to send all dates that are selected by the user to the payload
  const selectedCampaignDates = selectedRanges
    ?.filter((range) => range?.dates?.[0] && range?.dates?.[1])
    ?.map((range) => ({
      startDate: dayjs(range?.dates[0]).endOf("day").toISOString(),
      endDate: dayjs(range?.dates[1]).endOf("day").toISOString(),
    }));

  //Used to send all quantities in array format as per new slots
  const selectedCampaignQuantities = selectedRanges
    ?.filter((range) => range?.dates?.[0] && range?.dates?.[1])
    ?.map((range) => range?.quantity);

  // Function to handle adding product to campaign
  const handleAddCampaign = async () => {
    const utmSource = localStorage.getItem("utm_source");
    try {
      const activeCampaignId = campaignId || selectedCampaignId;
      const payload =
        activeCampaignId?.length && !isNewcampaign
          ? {
              type: "existing",
              product_id: product?.id,
              dates: selectedCampaignDates || [],
              campaign_id: activeCampaignId,
              quantity: selectedCampaignQuantities,
              ...(utmSource && {
                utm_source: utmSource,
              }),
            }
          : campaignDetails;
      await dispatch(createNewCampaign(payload)).unwrap();
      navigate(`/buyer/campaigndetails?_id=${btoa(activeCampaignId)}`);
      goToSubPage();
      localStorage.removeItem("campaignId");
      localStorage.removeItem("CampaignName");
      setSelectedCampaign(null);
      setCampaignName("");
      setDrawerVisible(false);
    } catch (error) {}
  };

  // Function to handle notify API call
  const handleNotifyApi = (values) => {
    const payload = {
      loggedinUser: {
        clientId: null,
        email: userDetails?.email,
        firstName: userDetails?.firstName,
        lastName: userDetails?.lastName,
        user_id: userDetails?.user_id,
        user_role: userDetails?.user_role,
        user_type: userDetails?.user_type,
      },
      product_id: product?.id,
      user_message: values?.user_message,
    };
    dispatch(productExpiryNotify(payload)).then(() => {
      form.resetFields();
    });
  };

  // Radio button change handler
  const handleCampaignChange = (e) => {
    setCampaignOption(e.target.value);
    setCampaignName(""); // Reset input
    setCampaignId(null);
    setSelectedCampaign(null);
  };

  // Set active image when product images change
  useEffect(() => {
    if (product?.image) {
      product?.insert_type ?? setActiveImage(product?.image[0]);
    }
  }, [product]);

  useEffect(() => {
    setProduct(singleProduct?.product_details);
  }, [singleProduct]);

  // Function to handle campaign selection from previous page
  useEffect(() => {
    if (isCampaignsPage) {
      setSelectedCampaign(campaignName);
    } else {
      setSelectedCampaign(null);
    }
  }, [isCampaignsPage]);

  // Function to handle thumbnail click
  const handleThumbnailClick = (img) => {
    if (showMap) {
      setShowMap(false);
    }
    setActiveImage(img);
  };

  // Function to handle campaign creation
  const handleCreateCampaign = async () => {
    const utmSource = localStorage.getItem("utm_source");
    setIsNewCampaign(true);
    const payload = {
      type: "new",
      name: campaignName,
      product_id: product?.id,
      dates: selectedCampaignDates || [],
      quantity: selectedCampaignQuantities,
      ...(utmSource && {
        utm_source: utmSource,
      }),
    };

    await dispatch(createNewCampaign(payload)).unwrap();
    setCampaignDetails(payload);
    navigate(`/buyer/mycampaigns`);
    setSelectedCampaign(campaignName);
    setDrawerVisible(false);
  };

  // Function to format dates
  const formatDate = (timestamp) => {
    if (!timestamp) return ""; // or return "-"
    const date = new Date(parseInt(timestamp, 10));
    if (isNaN(date.getTime())) {
      return "";
    }
    return new Intl.DateTimeFormat("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    }).format(date);
  };

  const updateActiveRange = (dates) => {
    setSelectedRanges((prev) =>
      prev.map((range, index) =>
        index === activeRangeIndex
          ? {
              ...range,
              dates,
              quantity: 0,
              availableQuantity: 0,
            }
          : range,
      ),
    );
  };
  // Check Whether date already belong to any other selected slot
  const isDateInAnotherRange = (date) => {
    return selectedRanges.some((range, index) => {
      if (index === activeRangeIndex) return false;
      const start = range?.dates?.[0];
      const end = range?.dates?.[1];
      if (!start || !end) return false;
      return (
        date.isSame(start, "day") ||
        date.isSame(end, "day") ||
        (date.isAfter(start, "day") && date.isBefore(end, "day"))
      );
    });
  };

  // check whether Are ALL dates between start and end available
  const isRangeFullyAvailable = (start, end) => {
    if (!start || !end) {
      return false;
    }
    let current = start.clone();
    // Keep looping until current reaches end date
    while (current.isSame(end, "day") || current.isBefore(end, "day")) {
      const dateToCheck = current;
      const isAvailable = availableSlots.some((slot) => {
        return (
          dateToCheck.isSame(slot.start, "day") ||
          dateToCheck.isSame(slot.end, "day") ||
          (dateToCheck.isAfter(slot.start, "day") &&
            dateToCheck.isBefore(slot.end, "day"))
        );
      });
      if (!isAvailable) {
        return false;
      }
      current = current?.add(1, "day");
    }
    return true;
  };

  // Function to handle date selection
  const handleSelect = (date) => {
    if (!date) {
      const updatedDates = [null, null];
      updateActiveRange(updatedDates);
      return;
    }
    const [start, end] = selectedDates;
    if (!start && !end) {
      const updatedDates = [date, undefined];
      updateActiveRange(updatedDates);
      return;
    }
    if (start && !end) {
      const rangeStart = date.isBefore(start, "day") ? date : start;
      const rangeEnd = date.isBefore(start, "day") ? start : date;
      if (!isRangeFullyAvailable(rangeStart, rangeEnd)) {
        message.warning("Selected range contains unavailable dates.");
        return;
      }
      let current = rangeStart.clone();
      while (
        current.isSame(rangeEnd, "day") ||
        current.isBefore(rangeEnd, "day")
      ) {
        if (isDateInAnotherRange(current)) {
          message.warning(
            "Selected date range overlaps with another reserved range.",
          );
          return;
        }
        current = current.add(1, "day");
      }
      const updatedDates = [rangeStart, rangeEnd];
      updateActiveRange(updatedDates);
      return;
    }

    if (start && end) {
      if (date.isBefore(end, "day")) {
        const updatedDates = [date, undefined];
        updateActiveRange(updatedDates);
      } else {
        const rangeStart = start;
        const rangeEnd = date;
        if (!isRangeFullyAvailable(rangeStart, rangeEnd)) {
          message.warning("Selected range contains unavailable dates.");
          return;
        }
        let current = rangeStart.clone();
        while (
          current.isSame(rangeEnd, "day") ||
          current.isBefore(rangeEnd, "day")
        ) {
          if (isDateInAnotherRange(current)) {
            message.warning(
              "Selected date range overlaps with another reserved range.",
            );
            return;
          }
          current = current.add(1, "day");
        }
        const updatedDates = [start, date];
        updateActiveRange(updatedDates);
      }
      return;
    }
  };
  const hasIncompleteRanges = selectedRanges.some((range) => {
    const start = range?.dates?.[0];
    const end = range?.dates?.[1];
    return !(start && end);
  });
  //disabling feature for the multi slot quantity having 0
  const hasZeroQuantityRange = selectedRanges.some((range) => {
    const hasDates = range?.dates?.[0] && range?.dates?.[1];
    return hasDates && Number(range?.availableQuantity) <= 0;
  });
  // Function to determine if "Add to Campaign" button should be disabled
  const getAddtoCampaignDisabled = () => {
    if (
      !(
        (isLoggedIn && selectedCampaign) ||
        selectedCampaignName ||
        campaignName !== ""
      ) ||
      !hasSelectedRanges ||
      hasIncompleteRanges ||
      hasZeroQuantityRange
    ) {
      return true;
    } else return false;
  };

  const accessToCampaignDrawer = useCallback(() => {
    if (!isLoggedIn) {
      setLoginPopoverVisible(true);
    } else {
      dispatch(getUserSavedCampaigns());
    }
  }, [dispatch, isLoggedIn]); //dependencies

  // Fetch product details on component mount
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      dispatch(getSingleProductDetails(atob(other_id)));
      accessToCampaignDrawer();
    } else if (!token) {
      dispatch(getSingleProductDetailsBeforeLogin(atob(other_id)));
    }
  }, [dispatch, other_id, accessToCampaignDrawer]);
  const getTableColumns = (product) => [
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
    },
    ...(product?.type === "Digital"
      ? [
          {
            title: "Quantity",
            dataIndex: "quantity",
            key: "quantity",
            align: "center",
          },
        ]
      : []),
  ];
  const getDateValues = (dateField) => {
    if (Array.isArray(dateField)) {
      return dateField;
    }
    return dateField ? [dateField] : [];
  };
  const getTableData = (product) => {
    if (!product) return [];

    const fromDates = getDateValues(product?.from_date);
    const toDates = getDateValues(product?.to_date);
    const quantities = product?.unitQty || [];

    return fromDates.map((from, index) => ({
      key: index,
      startDate: dayjs(Number(from?.$date?.$numberLong)).format("MMM DD, YYYY"),
      endDate: dayjs(Number(toDates?.[index]?.$date?.$numberLong)).format(
        "MMM DD, YYYY",
      ),
      quantity: product?.type === "Digital" ? (quantities[index] ?? "-") : "-",
    }));
  };

  // Find the latest to date of product availability date for the Notify Me functionality
  const latestToDate = Array.isArray(product?.to_date)
    ? Math.max(...product.to_date.map((d) => Number(d?.$date?.$numberLong)))
    : Number(product?.to_date?.$date?.$numberLong);

  const dateValidation = new Date(latestToDate) <= new Date();
  const fromDates = Array.isArray(product?.from_date)
    ? product?.from_date
    : product?.from_date
      ? [product.from_date]
      : [];
  const toDates = Array.isArray(product?.to_date)
    ? product?.to_date
    : product?.to_date
      ? [product.to_date]
      : [];
  const minFromTimestamp =
    fromDates.length > 0
      ? Math.min(...fromDates.map((item) => Number(item?.$date?.$numberLong)))
      : null;
  const maxToTimestamp =
    toDates.length > 0
      ? Math.max(...toDates.map((item) => Number(item?.$date?.$numberLong)))
      : null;
  const slotsLength = Math.max(fromDates.length, toDates.length);
  const popoverContent = (
    <div className="slots-popover">
      <div className="product-title" style={{ marginBottom: "10px" }}>
        Available Slots
      </div>
      <Table
        columns={getTableColumns(product)}
        dataSource={getTableData(product)}
        pagination={false}
        rowKey="key"
        size="small"
        className="billboard-table"
      />
    </div>
  );
  const minDays = product?.minimumdays || 0;

  // this count  total number of days selected by the user
  const totalSelectedDays = selectedRanges.reduce((total, range) => {
    const start = range?.dates?.[0];
    const end = range?.dates?.[1];
    if (!start || !end) return total;
    return total + end.diff(start, "day") + 1;
  }, 0);

  const handleCountOfDates = () => {
    return totalSelectedDays >= minDays ? totalSelectedDays : "-";
  };

  // Function to calculate total price based on product type and selected days
  const calculateTotalPrice = ({
    price,
    productType,
    selectedDays,
    minimumDays,
  }) => {
    const oneDayPrice = price / 28;
    let totalPrice = 0;
    if (productType === "variable") {
      totalPrice =
        Number(selectedDays) >= Number(minimumDays)
          ? Number(selectedDays) * Number(oneDayPrice)
          : Number(minimumDays) * Number(oneDayPrice);
    } else if (productType === "fixed") {
      if (Number(selectedDays) >= Number(minimumDays)) {
        const roundFactor = Math.ceil(
          Number(selectedDays) / Number(minimumDays),
        );
        // Round up to next whole
        const totalDays = roundFactor * Number(minimumDays);
        totalPrice = totalDays * Number(oneDayPrice);
      } else {
        totalPrice = Number(minimumDays) * Number(oneDayPrice);
      }
    }

    return totalPrice; // Optional: Round to nearest integer
  };

  // Calculate total price whenever selected dates change
  useEffect(() => {
    handleCountOfDates();
    const productdetails = {
      price: product?.default_price || 0, // valid number
      productType: product?.fix?.toLowerCase(), // 'fixed' or 'variable'
      selectedDays: handleCountOfDates(), // valid number
      minimumDays: product?.minimumdays || 0, // valid number
    };

    let v = calculateTotalPrice(productdetails);
    setTotalPrice(v);
  }, [selectedDates, product]);

  useEffect(() => {
    if (selectedDates[0]) {
      setPanelMonth(selectedDates[0]);
    }
  }, [selectedDates]);

  // Custom date cell renderer
  const dateRender = (current, today) => {
    const isSameMonth =
      current?.month() === (panelMonth?.month?.() ?? current?.month());
    // Disabled dates
    if (disableProductDatesForRangepicker(current)) {
      return (
        <div
          className="custom-cell disabled"
          onMouseEnter={() => {
            setHoveredDate(null);
          }}
        >
          {current?.date()}
        </div>
      );
    }
    // Already selected start/end dates
    const isStart = selectedRanges.some(
      (range) => range?.dates?.[0] && current?.isSame(range?.dates?.[0], "day"),
    );

    const isEnd = selectedRanges.some(
      (range) => range?.dates?.[1] && current?.isSame(range?.dates?.[1], "day"),
    );
    const startDate = selectedDates?.[0];
    const endDate = selectedDates?.[1];

    let isValidHoverRange = false;
    // Check whether hovering this date creates a valid range
    if (startDate && !endDate && current) {
      const rangeStart = current.isBefore(startDate, "day")
        ? current
        : startDate;

      const rangeEnd = current.isBefore(startDate, "day") ? startDate : current;

      let checkDate = rangeStart.clone();
      let hasDisabledDate = false;

      while (
        checkDate.isSame(rangeEnd, "day") ||
        checkDate.isBefore(rangeEnd, "day")
      ) {
        if (disableProductDatesForRangepicker(checkDate)) {
          hasDisabledDate = true;
          break;
        }

        checkDate = checkDate.add(1, "day");
      }

      if (!hasDisabledDate) {
        isValidHoverRange = true;
      }
    }
    const isInSelectedRange = selectedRanges.some(
      (range) =>
        range?.dates?.[0] &&
        range?.dates?.[1] &&
        !current.isBefore(range.dates[0], "day") &&
        !current.isAfter(range.dates[1], "day"),
    );
    const isInHoverPreview =
      startDate &&
      !endDate &&
      hoveredDate &&
      !current.isBefore(
        hoveredDate.isBefore(startDate, "day") ? hoveredDate : startDate,
        "day",
      ) &&
      !current.isAfter(
        hoveredDate.isBefore(startDate, "day") ? startDate : hoveredDate,
        "day",
      );
    const showRangeHighlight =
      isSameMonth &&
      (isInSelectedRange || isInHoverPreview) &&
      !isStart &&
      !isEnd;

    const className = [
      "custom-cell",
      isStart && isSameMonth && "start-date",
      isEnd && isSameMonth && "end-date",
    ]
      .filter(Boolean)
      .join(" ");
    return (
      <div
        className={className}
        style={
          showRangeHighlight
            ? { backgroundColor: "#fad0d9", borderRadius: 6 }
            : undefined
        }
        onMouseEnter={() => {
          if (startDate && !endDate && isValidHoverRange) {
            setHoveredDate(current);
          } else if (startDate && !endDate) {
            setHoveredDate(null);
          }
        }}
        onMouseLeave={() => {
          setHoveredDate(null);
        }}
        onClick={(e) => {
          e.stopPropagation();
          setHoveredDate(null);
          handleSelect(current);
        }}
      >
        {current?.date()}
      </div>
    );
  };

  //handle product quantity change
  const handleQuantityChange = (value) => {
    setSelectedQuantity(value);
  };

  // Generate an array of numbers for product quantity selection
  const numbers = Array.from(
    { length: productAvailabilityQuantity && productAvailabilityQuantity },
    (_, i) => i + 1,
  );
  // Get the Least  start date and latest end date from all fully selected date ranges
  const getMinMaxDates = () => {
    const validRanges = selectedRanges?.filter(
      (range) => range?.dates?.[0] && range?.dates?.[1],
    );
    if (!validRanges.length) {
      return {
        startDate: null,
        endDate: null,
      };
    }
    const startDate = Math.min(
      ...validRanges?.map((range) => range?.dates[0].valueOf()),
    );
    const endDate = Math.max(
      ...validRanges?.map((range) => range?.dates[1].valueOf()),
    );
    return { startDate, endDate };
  };

  // Memoize the calculated date range to avoid unnecessary recalculations on re-renders
  const activeRange = selectedRanges?.[activeRangeIndex];
  const startDate = activeRange?.dates?.[0];
  const endDate = activeRange?.dates?.[1];
  // Check product availability when selected dates change
  useEffect(() => {
    const activeRange = selectedRanges?.[activeRangeIndex];
    const startDate = activeRange?.dates?.[0];
    const endDate = activeRange?.dates?.[1];
    if (!startDate || !endDate || !product?.id) return;
    // Remember which slot this API call belongs to
    availabilityRequestRangeIdRef.current = activeRange?.id;
    const payload = {
      productId: product?.id,
      dates: `${dayjs(startDate)?.format("YYYY-MM-DD")}/${dayjs(
        endDate,
      )?.format("YYYY-MM-DD")}`,
    };
    const token = localStorage.getItem("token");
    const action = token
      ? checkProductAvailabilityQuantity(payload)
      : checkProductAvailabilityQuantityBeforeLogin(payload);

    dispatch(action).then((res) => {
      if (!res.payload) {
        return;
      }
      const availableQty = Number(res.payload) || 0;
      const rangeId = activeRange.id;
      setSelectedRanges((prev) => {
        const updated = prev?.map((range) => {
          const isMatched = range?.id === rangeId;
          if (!isMatched) return range;
          const updatedRange = {
            ...range,
            availableQuantity: availableQty,
            quantity:
              availableQty === 0
                ? 0
                : Math.min(Math.max(range.quantity ?? 1, 1), availableQty),
          };
          return updatedRange;
        });
        return updated;
      });
    });
  }, [
    selectedRanges?.[activeRangeIndex]?.dates?.[0],
    selectedRanges?.[activeRangeIndex]?.dates?.[1],
    product?.id,
    activeRangeIndex,
    dispatch,
  ]);
  // Set product locations for map
  useEffect(() => {
    if (product) {
      const lat = parseFloat(product?.lat);
      const lng = parseFloat(product?.lng);
      const title = product?.title;
      const productId = product?.id;
      if (!isNaN(lat) && !isNaN(lng)) {
        setProductLocations({
          lat,
          lng,
          title,
          productId,
          price: product?.rateCard,
          image: product?.image,
          city: product?.city,
        });
      }
    }
  }, [product]);
  // handling or updating the breadcrumbs while switching from the io
  useEffect(() => {
    if (isMobile) return;
    const params = new URLSearchParams(location.search);
    const title = params.get("title");
    if (title) {
      dispatch(
        addBreadcrumb({
          title,
          path: location.pathname + location.search,
        }),
      );
    }
  }, []);

  const columns = [
    {
      title: "Age",
      dataIndex: "age",
      key: "age",
      render: (text, record) =>
        record.isTotal ? (
          <Text className="audience-breakdown-total">{text}</Text>
        ) : (
          <Text className="impressions-column">{text}</Text>
        ),
    },
    {
      title: "Monthly Impression",
      dataIndex: "impressions",
      key: "impressions",

      render: (text, record) =>
        record.isTotal ? (
          <Text className="audience-breakdown-total">{text}</Text>
        ) : (
          <Text className="impressions-column">{text}</Text>
        ),
    },
    {
      title: "CPM",
      dataIndex: "cpm",
      key: "cpm",
      render: (text, record) =>
        record.isTotal ? (
          <Text className="audience-breakdown-total">{text}</Text>
        ) : (
          <Text className="impressions-column">{text}</Text>
        ),
    },
  ];

  const data = [
    {
      key: "1",
      age: "18-49",
      impressions: formatMetric(product?.firstImpression) || "-",
      cpm: formatToUSCurrency(product?.firstcpm),
    },
    {
      key: "2",
      age: "18+",
      impressions: formatMetric(product?.secondImpression) || "-",
      cpm: formatToUSCurrency(product?.cpm),
    },
    {
      key: "3",
      age: "25-54",
      impressions: formatMetric(product?.thirdImpression) || "-",
      cpm: formatToUSCurrency(product?.thirdcpm),
    },
    {
      key: "4",
      age: "Hispanic Adults 54",
      impressions: formatMetric(product?.forthImpression) || "-",
      cpm: formatToUSCurrency(product?.forthcpm),
    },
  ];

  //Fired when user try to add new slot
  const handleAddRange = () => {
    setSelectedRanges((prev) => [
      ...prev,
      {
        id: nextRangeIdRef.current++,
        label: `S${prev.length + 1}`,
        dates: [],
        quantity: 0,
        availableQuantity: 0,
      },
    ]);
    setActiveRangeIndex(selectedRanges.length);
  };

  const handleIncreaseQuantity = (index) => {
    setSelectedRanges((prev) =>
      prev?.map((range, i) => {
        if (i !== index) return range;
        const availableQty = Number(range?.availableQuantity) || 0;
        if (availableQty <= 0) {
          return {
            ...range,
            quantity: 0,
          };
        }
        return {
          ...range,
          quantity: Math.min(Number(range?.quantity ?? 1) + 1, availableQty),
        };
      }),
    );
  };

  const handleDecreaseQuantity = (index) => {
    setSelectedRanges((prev) =>
      prev?.map((range, i) => {
        if (i !== index) return range;
        const availableQty = Number(range?.availableQuantity) || 0;
        if (availableQty <= 0) {
          return {
            ...range,
            quantity: 0,
          };
        }
        return {
          ...range,
          quantity: Math.max(Number(range?.quantity ?? 1) - 1, 1),
        };
      }),
    );
  };
  //Fired when user try to delete existing slot
  const handleDeleteRange = (indexToDelete) => {
    const updatedRanges = selectedRanges
      ?.filter((_, index) => index !== indexToDelete)
      ?.map((range, index) => ({
        ...range,
        label: `S${index + 1}`,
      }));
    if (updatedRanges.length === 0) {
      const defaultRange = [
        {
          id: nextRangeIdRef.current++,
          label: "S1",
          dates: [],
          quantity: 0,
          availableQuantity: 0,
        },
      ];
      setSelectedRanges(defaultRange);
      setActiveRangeIndex(0);
      return;
    }
    setSelectedRanges(updatedRanges);
    const newActiveIndex =
      indexToDelete >= updatedRanges.length
        ? updatedRanges.length - 1
        : indexToDelete;
    setActiveRangeIndex(newActiveIndex);
    if (updatedRanges[newActiveIndex]?.dates?.[0]) {
      setPanelMonth(updatedRanges[newActiveIndex].dates[0]);
    }
  };

  const hasAvailableDatesLeft = () => {
    return availableSlots.some((slot) => {
      if (!slot?.start || !slot?.end) {
        return false;
      }
      let currentDate = slot.start.clone();
      while (
        currentDate.isSame(slot.end, "day") ||
        currentDate.isBefore(slot.end, "day")
      ) {
        const dateToCheck = currentDate;
        const isAlreadySelected = selectedRanges.some((range) => {
          const start = range?.dates?.[0];
          const end = range?.dates?.[1];
          if (!start || !end) return false;
          return (
            dateToCheck.isSame(start, "day") ||
            dateToCheck.isSame(end, "day") ||
            (dateToCheck.isAfter(start, "day") &&
              dateToCheck.isBefore(end, "day"))
          );
        });
        if (!isAlreadySelected) {
          return true;
        }
        currentDate = currentDate.add(1, "day");
      }
      return false;
    });
  };
  // Campaign Creation Component
  const campaignCreationComponent = (
    <Card className="product-info-card book-campaign-card" bordered={false}>
      {new Date(latestToDate) <= new Date() ? (
        <>
          <div className="notify-section-text">
            <div className="not-available-text">
              Opps - This product is currently unavailable. We can contact the
              seller and see when it will be available in the future. Just tell
              us what dates are you looking for
            </div>
            <div className="book-it-text">Looking to book it soon? </div>
          </div>
        </>
      ) : (
        <>
          <Row>
            <Text className="product-performance-title">
              Book This Product in 3 Easy Steps
            </Text>
          </Row>
          <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
            <Col span={23}>
              <div>
                <Text className="product-type-label">
                  Step 1:Choose Your Dates
                </Text>
                <div
                  // className="datepicker-container"
                  style={{
                    position: isLoading && "sticky",
                    width: "100%",
                  }}
                >
                  <RangePicker
                    className="multi-slot-range-picker"
                    open={true}
                    locale={customLocale}
                    // className="custom-calendar"
                    popupClassName="custom-calendar-popup custom-calendar-arrows multi-slot-popup"
                    ref={datePickerRef}
                    inputReadOnly
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    superNextIcon={false}
                    superPrevIcon={false}
                    pickerValue={panelMonth}
                    format="YYYY-MM-DD"
                    //value={selectedDates.length === 2 ? selectedDates : null}
                    value={null}
                    onPanelChange={(value, mode) => {
                      setPanelMonth(value[0]);
                      const currentMode = Array.isArray(mode) ? mode[0] : mode;
                      setPanelMode(currentMode);
                    }}
                    dateRender={(current) => dateRender(current, panelMonth)}
                    // onCalendarChange={handleDateSelect}
                    disabledDate={(current) => {
                      return disableProductDatesForRangepicker(current);
                    }}
                  />
                  <div className="multi-range-selection-wrapper">
                    {selectedRanges?.map((range, index) => (
                      <React.Fragment key={range?.id}>
                        <div
                          key={range?.id}
                          className={`multi-range-selection-box ${
                            activeRangeIndex === index ? "active-range" : ""
                          } ${range?.dates?.[0] && range?.dates?.[1] ? "clickable-range" : ""}`}
                          onClick={() => {
                            setActiveRangeIndex(index);
                          }}
                        >
                          <span>{range?.label}</span>
                          <span>
                            <ArrowRightOutlined />
                          </span>
                          <span className="range-date">
                            {range?.dates?.[0]
                              ? range.dates[0].format("YYYY-MM-DD")
                              : "select start"}
                          </span>
                          <span>&rarr;</span>
                          <span className="range-date">
                            {range?.dates?.[1]
                              ? range.dates[1].format("YYYY-MM-DD")
                              : activeRangeIndex === index && hoveredDate
                                ? hoveredDate.format("YYYY-MM-DD")
                                : "select end"}
                          </span>
                          <span className="range-days">
                            {range?.dates?.[0] &&
                            (range?.dates?.[1]
                              ? range.dates[1].diff(range.dates[0], "day") + 1
                              : activeRangeIndex === index && hoveredDate
                                ? Math.abs(
                                    hoveredDate.diff(range.dates[0], "day"),
                                  ) + 1
                                : null)
                              ? `${
                                  range?.dates?.[1]
                                    ? range.dates[1].diff(
                                        range.dates[0],
                                        "day",
                                      ) + 1
                                    : Math.abs(
                                        hoveredDate.diff(range.dates[0], "day"),
                                      ) + 1
                                } Days`
                              : ""}
                          </span>
                          {!(
                            index === 0 &&
                            !range?.dates?.[0] &&
                            !range?.dates?.[1]
                          ) && (
                            <span
                              className="delete-range-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDeleteRange(index);
                              }}
                            >
                              <CloseOutlined />
                            </span>
                          )}
                        </div>
                        {range?.dates?.[0] && range?.dates?.[1] && (
                          <div className="quantity-container">
                            <div className="quantity-info">
                              <p className="quantity-title">Quantity</p>
                              <p className="quantity-subtitle">
                                Slots per loop cycle
                              </p>
                            </div>
                            <div className="quantity-controls">
                              <Button
                                disabled={
                                  Number(range?.availableQuantity) <= 0 ||
                                  Number(range?.quantity) <= 1
                                }
                                className={`quantity-btn ${
                                  Number(range?.availableQuantity) <= 0 ||
                                  Number(range?.quantity) <= 1
                                    ? "quantity-btn-disabled"
                                    : ""
                                }`}
                                onClick={() => handleDecreaseQuantity(index)}
                              >
                                <MinusOutlined />
                              </Button>
                              <span className="quantity-value">
                                {range?.quantity ?? 0}
                              </span>
                              <Button
                                disabled={
                                  Number(range?.quantity) >=
                                  Number(range?.availableQuantity)
                                }
                                className={`quantity-btn ${
                                  Number(range?.quantity) >=
                                  Number(range?.availableQuantity)
                                    ? "quantity-btn-disabled"
                                    : ""
                                }`}
                                onClick={() => handleIncreaseQuantity(index)}
                              >
                                <PlusOutlined />
                              </Button>
                            </div>
                          </div>
                        )}
                      </React.Fragment>
                    ))}
                    <div
                      className={`add-another-range-btn ${
                        !hasAvailableDatesLeft() || hasIncompleteRanges
                          ? "disabled-add-range"
                          : ""
                      }`}
                      onClick={() => {
                        if (!hasAvailableDatesLeft()) return;
                        if (hasIncompleteRanges) {
                          return;
                        }
                        handleAddRange();
                      }}
                    >
                      <>
                        <PlusOutlined />
                        <span>Add another date range</span>
                      </>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                {totalSelectedDays > 0 &&
                  totalSelectedDays < Number(product?.minimumdays) && (
                    <>
                      <div className="minimum-err-txt-container">
                        <Text className="error-text">
                          Minimum booking: {product?.minimumdays} days required.
                        </Text>
                      </div>
                      <Row>
                        <Text className="warning-msg-text">
                          If selected days are less than {product?.minimumdays},
                          the same minimum price will apply.
                        </Text>
                      </Row>
                    </>
                  )}
              </div>
            </Col>
          </Row>
          <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
            <Col span={23}>
              <div>
                <Text className="product-type-label">
                  Step 2: Select or Create a Campaign
                </Text>
                <div>
                  <Radio.Group
                    size="large"
                    onChange={handleCampaignChange}
                    value={campaignOption}
                  >
                    <div>
                      <Radio className="radio-btn-campaign" value="existing">
                        Existing Campaign
                      </Radio>
                    </div>
                    <Radio className="radio-btn-campaign" value="new">
                      Create New Campaign
                    </Radio>
                  </Radio.Group>
                </div>

                <div className="create-new-campaign-popover">
                  {/* --- If Existing Campaign Selected --- */}
                  {campaignOption === "existing" && (
                    <div className="select-campaign-dropdown-div">
                      <Select
                        getPopupContainer={(triggerNode) =>
                          triggerNode.closest(".drawer-content")
                        }
                        dropdownStyle={{ zIndex: 2000 }}
                        disabled={!hasIncompleteRanges && hasZeroQuantityRange}
                        onClick={() => {
                          if (!isLoggedIn) {
                            setLoginPopoverVisible(true);
                          }
                        }}
                        suffixIcon={<SelectDownIcon />}
                        allowClear
                        placeholder="Select the Campaign"
                        className="select-campaign-dropdown"
                        bordered={false}
                        showArrow
                        value={
                          isCampaignsPage
                            ? selectedCampaign ||
                              selectedCampaignName ||
                              undefined
                            : selectedCampaign
                        }
                        onChange={(value, option) => {
                          setCampaignId(value);
                          setSelectedCampaign(option?.label);
                        }}
                        dropdownRender={(menu) => (
                          <div style={{ position: "relative" }}>
                            {buyerSavedCampaignsLoader ? (
                              <div
                                style={{
                                  padding: "20px 0",
                                  textAlign: "center",
                                }}
                              />
                            ) : (
                              <div className="user-campaign-list">
                                {savedCampaigns?.length ? (
                                  menu
                                ) : (
                                  <div
                                    className="common-css"
                                    style={{ padding: "8px 12px" }}
                                  >
                                    <Row justify="center">
                                      <span className="product-model-menu-empty">
                                        No Campaigns Found
                                      </span>
                                    </Row>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        )}
                      >
                        {!isLoading &&
                          savedCampaigns?.map((campaign) => (
                            <Select.Option
                              key={campaign.id}
                              value={campaign.id}
                              label={`${campaign.name} (${campaign.cid})`}
                            >
                              <Tooltip
                                title={`${campaign.name} (${campaign.cid})`}
                                placement="top"
                                overlayClassName="campaign-tooltip"
                              >
                                {campaign.name} ({campaign.cid})
                              </Tooltip>
                            </Select.Option>
                          ))}
                      </Select>
                    </div>
                  )}

                  {/* --- If New Campaign Selected --- */}
                  {campaignOption === "new" && (
                    <div className="select-campaign-dropdown-div">
                      <FloatingInput
                        className="billboard-input-feild"
                        label={<>{`Campaign Name `}</>}
                        rules={[
                          {
                            required: true,
                            message: "campaign name  required!",
                          },
                        ]}
                        customStyles={floatingInputStyles}
                        value={campaignName}
                        disabled={hasIncompleteRanges || hasZeroQuantityRange}
                        onChange={(e) => {
                          if (!isLoggedIn) {
                            setLoginPopoverVisible(true);
                          } else {
                            const title = e.target.value
                              ?.replace(/[\\/]/g, "")
                              ?.replace(/\s{2,}/g, " ");
                            setCampaignName(title);
                          }
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
            </Col>
          </Row>
          {/*  
          As per new changes we are hidding this feature
          <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
            <Col span={23}>
              <div>
                <Text className="product-type-label">
                  Step 3: Add to Campaign
                </Text>
              </div>
            </Col>
          </Row>
          <Row>
            <Select
              className="select-quantity-dropdown"
              placeholder="Available Quantity"
              style={{ width: 200 }}
              value={
                selectedQuantity
                  ? `Available Quantity: ${selectedQuantity}`
                  : undefined
              }
              disabled={
                !(!hasIncompleteRanges && productAvailabilityQuantity > 0)
              }
              onChange={handleQuantityChange}
            >
              {numbers?.map((num) => (
                <Option key={num} value={num}>
                  {num}
                </Option>
              ))}
            </Select>{" "}
          </Row> */}

          <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
            <Tooltip
              title={
                hasZeroQuantityRange
                  ? "No quantity available for selected dates."
                  : ""
              }
            >
              <Button
                type="primary"
                className={`addto-campain-btn ${
                  !isLoggedIn ? "disabled-button" : ""
                } ${getAddtoCampaignDisabled() ? "disable-add-tocart" : ""}`}
                disabled={
                  getAddtoCampaignDisabled() ||
                  new Date(Number(product?.to_date?.$date?.$numberLong)) <=
                    new Date()
                }
                onClick={() => {
                  campaignOption === "new"
                    ? handleCreateCampaign()
                    : handleAddCampaign();
                }}
              >
                {campaignOption === "new"
                  ? "Create New Campaign"
                  : "Add to Existing Campaign"}
              </Button>
            </Tooltip>
          </Row>

          <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
            <div>
              <Text className="product-type-label">
                You can edit or remove this billboard from your Campaign at
                anytime.
              </Text>
            </div>
          </Row>
        </>
      )}

      {dateValidation && (
        <Space direction="vertical" size={15}>
          <Form form={form} onFinish={handleNotifyApi}>
            <Row>
              <div className="drop-text-label">
                Drop us a quick note, and we'll let you know if it becomes
                available.
              </div>
              <FormItem
                style={{ width: "100%" }}
                name="user_message"
                rules={[
                  {
                    required: true,
                    message: "Message is required!",
                  },
                ]}
              >
                <FloatingTextArea
                  customStyles={textAreaFloatingInputStyles}
                  maxLength={500}
                  label={<>{`Message`}</>}
                  className="billboard-input-feild billboard-text-area"
                ></FloatingTextArea>
              </FormItem>
              <Button
                key={product?.id}
                className="details-btn billboard-button-2"
                type="primary"
                onClick={(e) => {
                  e.stopPropagation();
                  if (!isLoggedIn) {
                    setLoginPopoverVisible(true);
                    return;
                  } else {
                    form.submit();
                  }
                }}
              >
                <NotifyIcon
                  style={{ color: "#fff", width: "20px", height: "auto" }}
                />
                Notify me
              </Button>
            </Row>
          </Form>
        </Space>
      )}
    </Card>
  );
  const reservationBanner = (
    <div className="product-reservation-banner">
      <div className="product-reservation-main">
        <div className="product-reservation-icon">
          <LockOutlined />
        </div>
        <div className="product-reservation-content">
          <div className="product-reservation-title">
            {isOwnReservation
              ? "🔒 This ad space is currently reserved for you"
              : "⏳ This ad space is temporarily reserved"}
          </div>
          <div className="product-reservation-text">
            {isOwnReservation ? (
              <>
                You currently have an active reservation for this ad space while
                completing the Insertion Order signing process. Complete your
                signature before the reservation expires to secure your booking.
              </>
            ) : (
              <>
                Another buyer is in the process of signing their Insertion
                Order. This space will become available again when the hold
                expires or if the buyer does not complete signing.
              </>
            )}
          </div>
        </div>
        <div className="product-reservation-timer-wrapper">
          <div className="product-reservation-timer-label">
            {isOwnReservation ? "Reservation expires in" : "Available in"}
          </div>

          <div
            className={`product-reservation-timer ${
              isExpiringSoon ? "product-reservation-timer-warning" : ""
            }`}
          >
            <ClockCircleOutlined />
            <Countdown
              value={expiryTimestamp}
              format="mm:ss"
              valueStyle={{
                color: "#fff",
                fontSize: 24,
                fontWeight: 700,
                marginBottom: 0,
              }}
              onFinish={() => {
                setIsExpiringSoon(false);
              }}
              onChange={(value) => {
                if (!value) {
                  return;
                }
                setIsExpiringSoon(value <= 2 * 60 * 1000);
              }}
            />
          </div>
          <div className="product-reservation-footer-label">
            {isOwnReservation
              ? "Complete signing before expiry"
              : isExpiringSoon
                ? "Almost available!"
                : "If not completed"}
          </div>
        </div>
      </div>
      <div className="product-reservation-footer">
        <WarningOutlined />
        <span>
          {isOwnReservation
            ? "Your reservation will be released automatically if the signing process is not completed before the timer expires."
            : "Reservations last 10 minutes. If the buyer doesn't sign in time, this space will be released automatically."}
        </span>
      </div>
    </div>
  );

  //for mobile view add campaign drawer
  const handleAddCampaignDrawer = () => {
    setDrawerVisible(true);
  };

  const ZOOM = 1.5;

  // decided from the real pointer (mouse or touch), not from a media query
  const [isTouch, setIsTouch] = useState(false);
  const pointerTypeRef = useRef("mouse");

  const innerZoom = isExtraSmall; // in-place zoom
  const paneOverCalendar = isSmall && !innerZoom; // pane beside the image

  const imageContainerRef = useRef(null);
  const [showZoom, setShowZoom] = useState(false);
  const [lensPos, setLensPos] = useState({ x: 0, y: 0 });
  const [zoomPct, setZoomPct] = useState({ x: 50, y: 50 });
  const [paneSize, setPaneSize] = useState(null);

  const mainImageUrl =
    product?.insert_type && product?.insert_type !== "Bulk_state"
      ? product?.insert_type === "Bulk_state_Test"
        ? `${API_BASE_URL_IMAGE}${product?.image?.[0]}`
        : product?.image?.[0]
      : product?.image?.[0]
        ? `${API_BASE_URL_IMAGE}${activeImage ? activeImage : product?.image?.[0]}`
        : activeImage
          ? activeImage
          : dummyImage;

  const clamp = (v, min, max) => Math.max(min, Math.min(v, max));

  const updateZoomPosition = (clientX, clientY) => {
    const rect = imageContainerRef.current?.getBoundingClientRect();
    if (!rect) return;

    const lensW = rect.width / ZOOM;
    const lensH = rect.height / ZOOM;

    const lensX = clamp(clientX - rect.left - lensW / 2, 0, rect.width - lensW);
    const lensY = clamp(clientY - rect.top - lensH / 2, 0, rect.height - lensH);
    setLensPos({ x: lensX, y: lensY });

    if (innerZoom) {
      setZoomPct({
        x: clamp(((clientX - rect.left) / rect.width) * 100, 0, 100),
        y: clamp(((clientY - rect.top) / rect.height) * 100, 0, 100),
      });
    } else {
      const maxX = rect.width - lensW;
      const maxY = rect.height - lensH;
      setZoomPct({
        x: maxX > 0 ? (lensX / maxX) * 100 : 0,
        y: maxY > 0 ? (lensY / maxY) * 100 : 0,
      });
    }

    if (paneOverCalendar) {
      const available = window.innerWidth - rect.right - 32;
      const w = clamp(available, 260, 520);
      setPaneSize({
        w,
        h: (w * rect.height) / rect.width,
        left: rect.right + 16, // just right of the image, in screen coordinates
        top: rect.top,
      });
    } else {
      setPaneSize(null);
    }
  };

  // remember what kind of pointer is being used
  const handlePointerDown = (e) => {
    pointerTypeRef.current = e.pointerType;
    setIsTouch(e.pointerType !== "mouse");
  };

  // mouse: hover to zoom
  const handlePointerEnter = (e) => {
    if (e.pointerType === "mouse") {
      setIsTouch(false);
      setShowZoom(true);
    }
  };
  const handlePointerMove = (e) => {
    if (e.pointerType === "mouse" || showZoom) {
      updateZoomPosition(e.clientX, e.clientY);
    }
  };
  const handlePointerLeave = (e) => {
    if (e.pointerType === "mouse") setShowZoom(false);
  };

  // touch: tap to zoom, tap again to exit (drag pans while zoomed)
  const handleTap = (e) => {
    if (pointerTypeRef.current === "mouse") return;
    if (showZoom) {
      setShowZoom(false);
    } else {
      updateZoomPosition(e.clientX, e.clientY);
      setShowZoom(true);
    }
  };

  const showAIPrice = (productId) => {
    if (!isLoggedIn) {
      setLoginPopoverVisible(true);
    } else {
      // passDataToParent(true);
      setPredictedPrice([{ productuniqueId: productId, rateCard: 0 }]);
      setProductId(productId);
      dispatch(getPricePredictionOfProducts({ product_id: productId }));
    }
  };
  return (
    <div>
      <LoginAlert
        loginPopoverVisible={loginPopoverVisible}
        setLoginPopoverVisible={setLoginPopoverVisible}
      />
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        {!isExtraSmall && (
          <Row>
            <Col span={20} offset={isSmall ? 1 : 1}>
              <div className="breadcrumb-nav-container">
                <BreadcrumbNav />
              </div>
            </Col>
          </Row>
        )}
      </Space>
      {/* {isProductReserved && (
        <Row>
          <Col xl={23} sm={23} offset={1} className="card-width-adjustments">
            {reservationBanner}
          </Col>
        </Row>
      )} */}
      <div>
        <div className="product-info-outer">
          <div className="product-information-div">
            <Row>
              <Col
                xl={23}
                offset={isSmall ? 1 : 1}
                className="card-width-adjustments"
              >
                <Card className="product-info-card">
                  <Row>
                    <Col xl={12} md={24} sm={24}>
                      <div className="product-detail-image-container">
                        <div
                          ref={imageContainerRef}
                          className={`main-product-image-wrapper ${
                            innerZoom ? "is-inner-zoom" : ""
                          } ${isTouch && showZoom ? "is-touch-zooming" : ""}`}
                          onPointerDown={handlePointerDown}
                          onPointerEnter={handlePointerEnter}
                          onPointerMove={handlePointerMove}
                          onPointerLeave={handlePointerLeave}
                          onClick={handleTap}
                        >
                          <div style={{ height: "100%", width: "100%" }}>
                            {product?.insert_type &&
                            product?.insert_type !== "Bulk_state" ? (
                              <Image
                                src={
                                  product?.insert_type == "Bulk_state_Test"
                                    ? `${API_BASE_URL_IMAGE}` +
                                      product?.image?.[0]
                                    : product?.image[0]
                                }
                                preview={false}
                                alt=""
                                height={"100%"}
                                width={"100%"}
                              />
                            ) : product?.image && product?.image?.[0] ? (
                              <>
                                <Image
                                  src={`${API_BASE_URL_IMAGE}${
                                    activeImage
                                      ? activeImage
                                      : product?.image?.[0]
                                  }`}
                                  preview={false}
                                  alt="product-image"
                                  height={"100%"}
                                  width={"100%"}
                                />
                              </>
                            ) : (
                              <>
                                <Image
                                  src={activeImage ? activeImage : dummyImage}
                                  preview={false}
                                  alt="product-image"
                                  height={"100%"}
                                  width={"100%"}
                                />
                              </>
                            )}
                          </div>

                          {showZoom && (
                            <>
                              {!innerZoom && (
                                <div
                                  className="zoom-lens"
                                  style={{
                                    width: `${100 / ZOOM}%`,
                                    height: `${100 / ZOOM}%`,
                                    left: lensPos.x,
                                    top: lensPos.y,
                                  }}
                                />
                              )}

                              {(() => {
                                const pane = (
                                  <div
                                    className="product-image-zoom"
                                    style={{
                                      backgroundImage: `url("${mainImageUrl}")`,
                                      backgroundSize: `${ZOOM * 100}% ${ZOOM * 100}%`,
                                      backgroundPosition: `${zoomPct.x}% ${zoomPct.y}%`,
                                      ...(paneOverCalendar &&
                                        paneSize && {
                                          position: "fixed",
                                          left: paneSize.left,
                                          top: paneSize.top,
                                          width: paneSize.w,
                                          height: paneSize.h,
                                        }),
                                    }}
                                  />
                                );
                                // 997px to 1200px: float above everything; otherwise stay inside the wrapper
                                return paneOverCalendar
                                  ? paneSize &&
                                      createPortal(pane, document.body)
                                  : pane;
                              })()}
                            </>
                          )}
                        </div>

                        {images?.length > 0 && (
                          <Row className="image-thumbnail-row">
                            {product?.insert_type &&
                            product?.insert_type !== "Bulk_state"
                              ? images?.map((img, index) => (
                                  <Image
                                    key={index}
                                    preview={false}
                                    src={
                                      product?.insert_type == "Bulk_state_Test"
                                        ? `${API_BASE_URL_IMAGE}` +
                                          product?.image?.[0]
                                        : product?.image[0]
                                    }
                                    alt={`thumbnail - ${index + 1}`}
                                    className={`thumbnail-img ${
                                      activeImage === img
                                        ? "active-thumbnail"
                                        : ""
                                    }`}
                                    onClick={() => handleThumbnailClick(img)}
                                  />
                                ))
                              : images?.map((img, index) => (
                                  <Image
                                    key={index}
                                    preview={false}
                                    src={`${API_BASE_URL_IMAGE}` + img}
                                    alt={`thumbnail - ${index + 1}`}
                                    className={`thumbnail-img ${
                                      activeImage === `${img}`
                                        ? "active-thumbnail"
                                        : ""
                                    }`}
                                    onClick={() => handleThumbnailClick(img)}
                                  />
                                ))}
                          </Row>
                        )}
                      </div>
                      <div></div>
                    </Col>
                    <Col xl={12} md={24} className="product-highlight-detail">
                      <div>
                        <span className="product-copy-text-field">
                          <Text className="product-site-no">
                            {product?.siteNo}
                          </Text>
                          <CopyOutlined
                            onClick={(e) => {
                              e.stopPropagation(); // prevent tooltip close
                              handleCopy(product?.siteNo);
                            }}
                            className="copy-icon"
                          />
                        </span>
                        <span style={{ paddingLeft: 18 }}>
                          {new Date(
                            Number(product?.to_date?.$date?.$numberLong),
                          ) <= new Date() && (
                            <Badge
                              className="notify-badge"
                              count={"Not Available"}
                            />
                          )}
                        </span>
                        <br />
                        <span className="product-copy-text-field">
                          <Text className="product-title">
                            {product?.title}
                          </Text>
                          <CopyOutlined
                            onClick={(e) => {
                              e.stopPropagation(); // prevent tooltip close
                              handleCopy(product?.title);
                            }}
                            className="copy-icon"
                          />
                        </span>
                        <br />
                        <Row>
                          <Col span={24}>
                            <Text className="similar-product-id">
                              Available
                            </Text>
                          </Col>
                          <Col span={24}>
                            <Text className="similar-product-date">
                              {formatDate(minFromTimestamp)}
                            </Text>
                            <Arrow height={12} width={34} />
                            <Text className="similar-product-date">
                              {formatDate(maxToTimestamp)}
                            </Text>
                          </Col>
                          {slotsLength > 1 && (
                            <Popover
                              placement="right"
                              trigger="click"
                              content={popoverContent}
                            >
                              <span className="view-slots-link">
                                View Slots
                              </span>
                            </Popover>
                          )}
                        </Row>
                      </div>
                      <Divider />
                      <div>
                        <Text className="product-location">Location</Text>
                        <br />
                        <Text className="product-type-value">
                          {formatLocation(product)}
                        </Text>
                      </div>
                      <Divider />
                      <div>
                        <Text className="product-location">Total Price</Text>
                        <br />
                        {hasSelectedRanges ? (
                          <>
                            <Text className="product-price">
                              {formatToUSCurrency(
                                parseFloat(
                                  totalSelectedDays > 0 ? totalPrice : 0,
                                ).toFixed(2),
                              )}
                            </Text>
                            <Text className="total-selected-days">
                              {" "}
                              for {`${totalSelectedDays || 0} Days`}
                            </Text>
                          </>
                        ) : (
                          <>
                            <Text className="product-price">
                              {formatToUSCurrency(
                                Number(product?.rateCard)?.toFixed(2),
                              ) || "N/A"}
                            </Text>
                            <Text>4-Week Cost</Text>
                          </>
                        )}

                        <br />
                        {/* <Popover
                          content={popoverPriceBreakdownContent}
                          trigger="click"
                          placement="bottom"
                        >
                          <a className="view-full-price-breakdown">
                            View full price Breakdown
                          </a>
                        </Popover> */}
                        <br />
                        <>
                          {Number(product?.rateCard) === 0 && (
                            <>
                              {product?.id === productId &&
                              predictedPrice.length > 0 ? (
                                predictionLoader ? (
                                  <div className="product-card-loader">
                                    <Spin size="small" />
                                  </div>
                                ) : (
                                  <Badge
                                    count={
                                      <span>
                                        <div>
                                          <span className="price-text">
                                            {formatToUSCurrency(
                                              getPredictedPrice(
                                                prices?.predicted_price
                                                  ?.estimated_price,
                                              ),
                                            )}
                                          </span>

                                          <span className="per-week">
                                            {" "}
                                            Per 4 Weeks
                                          </span>
                                        </div>

                                        <div className="range-section">
                                          <Image
                                            className="sparkles"
                                            src={ChatBotSparkles}
                                            preview={false}
                                          />

                                          <span className="default-color">
                                            {" "}
                                            Estimated Market Value
                                          </span>

                                          <Tooltip
                                            placement="top"
                                            title={estimatedPriceTooltip()}
                                          >
                                            <InfoCircleOutlined />
                                          </Tooltip>

                                          <div className="price-range">
                                            Range:{" "}
                                            {formatToUSCurrency(
                                              getPredictedPrice(
                                                prices?.predicted_price
                                                  ?.price_lower_limit,
                                              ),
                                            )}
                                            {" - "}
                                            {formatToUSCurrency(
                                              getPredictedPrice(
                                                prices?.predicted_price
                                                  ?.price_upper_limit,
                                              ),
                                            )}
                                          </div>
                                        </div>
                                      </span>
                                    }
                                    color="#f5f5f5"
                                  />
                                )
                              ) : (
                                <Text
                                  strong
                                  className="ai-price"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    showAIPrice(product?.id);
                                  }}
                                >
                                  Estimated Market Value
                                </Text>
                              )}
                            </>
                          )}
                        </>
                        <div className="price-breakdown-info">
                          <Info />
                          <Text className="price-breakdown-info-text">
                            This includes install, AMP services, taxes, and
                            more. Pricing may vary based on the selected dates.
                          </Text>
                        </div>
                      </div>
                      {/* <Divider /> */}
                      {/* <div>
                        <Row justify="center" align="middle">
                          <Col span={8}>
                            <div>
                              <SealCheck />
                            </div>
                            <Text className="product-type-label">Audited</Text>
                          </Col>
                          <Col span={8}>
                            <div>
                              <ChartLine />
                            </div>
                            <Text className="product-type-label">
                              Media HHI
                            </Text>
                          </Col>
                          <Col span={8}>
                            <div>
                              <CalendarX />
                            </div>
                            <Text className="product-type-label">
                              Free Cancellation
                            </Text>
                          </Col>
                        </Row>
                      </div> */}
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col
                xl={12}
                sm={23}
                offset={isSmall ? 1 : 1}
                className="card-width-adjustments"
              >
                <Card className="audience-breakdown-card">
                  <Row>
                    <Text className="product-performance-title">
                      Audience Breakdown
                    </Text>
                  </Row>
                  <Row>
                    <Col span={24}>
                      <Table
                        columns={columns}
                        dataSource={data}
                        pagination={false}
                        size="small"
                        bordered={false}
                        showHeader={true}
                        style={{ borderRadius: 8 }}
                      />
                    </Col>
                  </Row>
                </Card>
              </Col>
              <Col
                xl={11}
                sm={23}
                offset={isExtraSmall ? 1 : 0}
                className="card-width-adjustments"
              >
                <Card className="audience-breakdown-card map-billboard-card">
                  <Row>
                    <Text className="product-performance-title">
                      See this billboard on the map{" "}
                    </Text>
                  </Row>
                  <div className="maps-card-section">
                    <GoogleMapsComponent
                      className="google-map-container"
                      isProductModal={true}
                      productLocations={productLocations}
                    />{" "}
                  </div>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col
                xl={12}
                // lg={8}
                sm={23}
                offset={isSmall ? 1 : 1}
                className="card-width-adjustments"
              >
                <Card className="product-performance-card">
                  <Row>
                    <Text className="product-performance-title">
                      Product Information
                    </Text>
                  </Row>
                  <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    <Col span={12}>
                      <div>
                        <Text className="product-type-label">Product Type</Text>
                      </div>
                      <Text className="product-type-value">
                        {" "}
                        {product?.type || "N/A"}
                      </Text>
                    </Col>
                    <Col span={12}>
                      <div>
                        <Text className="product-type-label">Dimensions</Text>
                      </div>
                      <Text className="product-type-value">
                        {formatBillboardSize(product?.height)} X{" "}
                        {formatBillboardSize(product?.width)}
                      </Text>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    <Col span={12}>
                      <div>
                        <Text className="product-type-label">Minimum Days</Text>
                      </div>
                      <Text className="product-type-value">
                        {" "}
                        {product?.minimumdays || "N/A"}
                      </Text>
                    </Col>
                    <Col span={12}>
                      {/* <div>
                        <Text className="product-type-label">Audited</Text>
                      </div>
                      <Text className="product-type-value">
                        {" "}
                        {product?.audited || "N/A"}
                      </Text> */}
                      <div>
                        <Text className="product-type-label">Comments</Text>
                      </div>
                      <Text className="product-type-value">
                        {product?.Comments || "N/A"}
                      </Text>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    <Col span={12}>
                      <div>
                        <Text className="product-type-label">
                          Fixed/Variables{" "}
                        </Text>
                      </div>
                      <Text className="product-type-value">
                        {" "}
                        {product?.fix || "N/A"}
                      </Text>
                    </Col>
                    <Col span={12}>
                      <div>
                        <Text className="product-type-label">
                          Product Direction
                        </Text>
                      </div>
                      <Text className="product-type-value">
                        {product?.imgdirection || "N/A"}
                      </Text>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    <Col span={12}>
                      <div>
                        <Text className="product-type-label">Facing </Text>
                      </div>
                      <Text className="product-type-value">
                        {product?.direction || "N/A"}{" "}
                      </Text>
                    </Col>
                    <Col span={12}>
                      <div>
                        <Text className="product-type-label">Flip Length</Text>
                      </div>
                      <Text className="product-type-value">
                        {product?.fliplength || "N/A"}
                      </Text>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    <Col span={12}>
                      <div>
                        <Text className="product-type-label">
                          {" "}
                          {product?.type === "Media"
                            ? "Break / Loop Length "
                            : "Loop Length"}{" "}
                        </Text>
                      </div>
                      <Text className="product-type-value">
                        {" "}
                        {product?.ageloopLength || "N/A"}
                      </Text>
                    </Col>
                    <Col span={12}>
                      <div>
                        <Text className="product-type-label">Description</Text>
                      </div>
                      <Tooltip title={product?.description || "N/A"}>
                        <Text className="product-type-value ">
                          {product?.description || "N/A"}
                        </Text>
                      </Tooltip>
                    </Col>
                  </Row>
                  {/* <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    <Col span={12}>
                      <div>
                        <Text className="product-type-label">Comments</Text>
                      </div>
                      <Text className="product-type-value">
                        {product?.Comments || "N/A"}
                      </Text>
                    </Col>
                  </Row> */}
                </Card>
              </Col>

              {/* Product Location & Seller Info Cards */}
              <Col
                xl={11}
                // lg={7}
                sm={23}
                offset={isExtraSmall ? 1 : 0}
                className="card-width-adjustments"
              >
                <Card className="product-location-card">
                  <Row>
                    <Text className="product-performance-title">
                      Location Details
                    </Text>
                  </Row>
                  <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    <Col span={12}>
                      <div>
                        <Text className="product-type-label">Address 1</Text>
                      </div>
                      <Text className="product-type-value">
                        {" "}
                        {product?.address || "N/A"}
                      </Text>
                    </Col>
                    <Col span={12}>
                      <div>
                        <Text className="product-type-label">Address 2</Text>
                      </div>
                      <Text className="product-type-value">
                        {formatLocation(product)}
                      </Text>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    <Col span={12}>
                      <div>
                        <Text className="product-type-label">Latitude</Text>
                      </div>
                      <Text className="product-type-value">
                        {" "}
                        {product?.lat || "N/A"}
                      </Text>
                    </Col>
                    <Col span={12}>
                      <div>
                        <Text className="product-type-label">Longitude</Text>
                      </div>
                      <Text className="product-type-value">
                        {" "}
                        {product?.lng || "N/A"}{" "}
                      </Text>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    <Col>
                      <div>
                        <Text className="product-type-label">
                          Location Description
                        </Text>
                      </div>
                      <Text className="product-type-value">
                        {product?.locationDesc || "N/A"}
                      </Text>
                    </Col>
                  </Row>
                </Card>
                <Card className="product-seller-info-card">
                  <Row>
                    <Text className="product-performance-title">
                      Seller Information
                    </Text>
                  </Row>
                  <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    <Col>
                      <div>
                        <Text className="product-type-label">Seller ID</Text>
                      </div>
                      <Text className="product-type-value">
                        {" "}
                        {product?.sellerId || "N/A"}
                      </Text>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>

            <Row className="booking-policy-section">
              <Col
                xl={12}
                // lg={8}
                sm={23}
                offset={isSmall ? 1 : 1}
                className="card-width-adjustments"
              >
                <Card className="product-pricebooking-card">
                  <Row>
                    <Text className="product-performance-title">
                      Pricing & Booking Card
                    </Text>
                  </Row>
                  <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    {product?.unitQty &&
                      (product?.type !== "Digital" ||
                        !Array.isArray(product?.unitQty)) && (
                        <Col span={12}>
                          <div>
                            <Text className="product-type-label">
                              Unit Quantity
                            </Text>
                          </div>
                          <Text className="product-type-value">
                            {product?.unitQty || "N/A"}
                          </Text>
                        </Col>
                      )}
                    {/* <Col span={12}>
                      <div>
                        <Text className="product-type-label">Media HHI</Text>
                      </div>
                      <Text className="product-type-value">
                        {" "}
                        {product?.mediahhi || "N/A"}
                      </Text>
                    </Col> */}
                    <Col span={12}>
                      <div>
                        <Text className="product-type-label">AMP Services</Text>
                      </div>
                      <Text className="product-type-value">
                        {product?.servicingYes === ""
                          ? product?.servicingNo === ""
                            ? product?.servicingYes
                            : product?.servicingNo
                          : product?.servicingYes}
                      </Text>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    <Col span={12}>
                      <div>
                        <Text className="product-type-label">
                          # of 4-Week Periods
                        </Text>
                      </div>
                      <Text className="product-type-value">
                        {" "}
                        {Number(product?.weekPeriod)?.toFixed(2) || "N/A"}
                      </Text>
                    </Col>
                    <Col span={12}>
                      <div>
                        <Text className="product-type-label">
                          # of 4-Week Price Net Cost
                        </Text>
                      </div>
                      <Text className="product-type-value">
                        {" "}
                        {formatToUSCurrency(
                          Number(product?.rateCard)?.toFixed(2),
                        ) || "N/A"}
                      </Text>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    <Col span={12}>
                      <div>
                        <Text className="product-type-label">Install Cost</Text>
                      </div>
                      <Text className="product-type-value">
                        {" "}
                        {formatToUSCurrency(
                          Number(product?.installCost)?.toFixed(2),
                        )}
                      </Text>
                    </Col>
                    <Col span={12}>
                      <div>
                        <Text className="product-type-label">
                          Tax Percentage
                        </Text>
                      </div>
                      <Text className="product-type-value">
                        {" "}
                        {product?.tax_percentage || "N/A"}
                      </Text>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    <Col span={12}>
                      <div>
                        <Text className="product-type-label">AMP Bills</Text>
                      </div>
                      <Text className="product-type-value">
                        {product?.billingYes === ""
                          ? product?.billingNo === ""
                            ? product?.billingYes
                            : product?.billingNo
                          : product?.billingYes}
                      </Text>
                    </Col>
                  </Row>
                </Card>
              </Col>
              <Col
                xl={11}
                // lg={7}
                sm={23}
                offset={isExtraSmall ? 1 : 0}
                className="card-width-adjustments"
              >
                <Card className="product-pricebooking-card">
                  <Row>
                    <Text className="product-performance-title">
                      Policy & Terms Card
                    </Text>
                  </Row>
                  <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    <Col span={24}>
                      <div>
                        <Text className="product-type-label">
                          Cancellation Policy
                        </Text>
                      </div>
                      <Text className="product-type-value">
                        {product?.cancellation_policy || "N/A"}{" "}
                      </Text>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    <Col>
                      <div>
                        <Text className="product-type-label">
                          Payments Terms
                        </Text>
                      </div>
                      <Text className="product-type-value">
                        {product?.cancellation_terms || "N/A"}
                      </Text>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    <Col span={24}>
                      <div>
                        <Text className="product-type-label">Restrictions</Text>
                      </div>
                      <Text className="product-type-value">
                        {product?.notes || "N/A"}
                      </Text>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>
            {/* {isExtraSmall && <FooterSection />} */}
          </div>
          <div className="product-booking-section">
            <Col
              span={22}
              offset={isExtraSmall ? 1 : 0}
              className="card-width-adjustments"
            >
              {campaignCreationComponent}
            </Col>
          </div>
        </div>
        <FooterSection />
      </div>

      {isExtraSmall && (
        <>
          <div>
            <Card className="fixed-bottom-bar-add-to-campaign">
              <Row justify="center">
                <Button
                  style={{
                    width: "100%",
                    height: 47,
                    backgroundColor: "#d2042d",
                  }}
                  onClick={handleAddCampaignDrawer}
                >
                  <Text
                    style={{ color: "#fff", fontSize: 16, fontWeight: 500 }}
                  >
                    Add to Campaign
                  </Text>
                </Button>
              </Row>
            </Card>
          </div>
          <div>
            <Drawer
              height={600}
              placement="bottom"
              closable={false}
              onClose={() => setDrawerVisible(false)}
              open={drawerVisible}
              keyboard={false}
              maskClosable={true}
              autoFocus={false} // ✅ Prevent focus re-trapping inside drawer
              destroyOnClose={false}
              styles={{
                body: { paddingBottom: 0 },
                wrapper: { pointerEvents: "auto" },
              }}
            >
              <Row
                justify="center"
                style={{ marginBottom: 16 }}
                className="drawer-body-wrapper"
              >
                {campaignCreationComponent}
              </Row>
            </Drawer>
          </div>
        </>
      )}

      {isLoading && <Spin size="large" fullscreen />}
    </div>
  );
};

export default ProductDetailPage;
